module.exports = __webpack_public_path__ + "assets/collector-desktop.4e6a0cd473c2d0664147e4af07d3b682.png";